import { Link, Outlet } from "react-router-dom";
import { MobileMenuSheet } from "@/components/common";
import icRocket from "@/assets/icons/ic-rocket.svg";
import { Footer } from "@/components/landing/footer";
import LogoMobile from "@/assets/images/mobile-logo.svg";

interface AuthLayoutProps {
  children?: React.ReactNode;
}

export const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <div className="min-h-svh bg-white flex flex-col relative">
      <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-black/[0.045]">
        <div className="max-w-[1440px] mx-auto flex items-center justify-between px-5 h-[64px] lg:px-8 lg:h-[88px] w-full">
          <Link to="/" aria-label="홈으로 돌아가기" className="flex items-center">
            <img src={LogoMobile} alt="PwC AI Agent Marketplace" className="lg:hidden w-3/4" />
            <img
              src="/images/logos/logo-pwc-pc.svg"
              alt="PwC AI Agent Marketplace"
              className="hidden lg:block  w-3/4"
            />
          </Link>
          <MobileMenuSheet>
            {({ close }) => (
              <>
                <div className="flex flex-col gap-1">
                  <Link
                    to="/"
                    onClick={close}
                    className="flex items-center gap-3 px-2 py-2 rounded hover:bg-black/[0.04]"
                  >
                    <img src={icRocket} alt="" width={24} height={24} />
                    <span className="text-base font-medium text-black">AX News</span>
                  </Link>
                </div>
                <div className="flex flex-col gap-3 ">
                  <Link
                    to="/signup"
                    onClick={close}
                    className="flex items-center justify-center w-full h-[48px] bg-[#EBEBEB] text-black text-base font-bold rounded-[4px]"
                  >
                    Sign up
                  </Link>
                  <Link
                    to="/login"
                    onClick={close}
                    className="flex items-center justify-center w-full h-[48px] bg-[#FFAA72] text-black text-base font-bold rounded-[4px]"
                  >
                    Log in
                  </Link>
                </div>
              </>
            )}
          </MobileMenuSheet>
        </div>
      </nav>
      <main className="flex-1 flex flex-col relative">
        <div
          className="absolute bottom-0 left-0 w-full h-[404px] pointer-events-none"
          // style={{
          //   backgroundImage: "url(/images/auth-bg-25140a.png)",
          //   backgroundSize: "100% 100%",
          //   backgroundRepeat: "no-repeat",
          // }}
        />
        <div className="relative flex-1 flex flex-col">{children ?? <Outlet />}</div>
      </main>
      <Footer />
    </div>
  );
};
